import React, { useState, useEffect } from 'react'
import SBNav from '../../shared/components/SideBarNav/SBNav'
import './privacy.scss'
import Footer from '../../components/Footer/Footer'

const Privacy = () => {

    useEffect(() => {
        document.title = 'FlashRoom Privacy'
    }, [])

    const [nav, openNav] = useState(false);


    useEffect(() => {
        if (!nav) {
            document.documentElement.classList.remove("nav-blur");
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";
            return;
        }

        const scrollY = window.scrollY;

        document.documentElement.classList.add("nav-blur");

        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = "100%";

        return () => {
            document.documentElement.classList.remove("nav-blur");
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";

            window.scrollTo(0, scrollY);
        };
    }, [nav]);


    return (
        <div id='privacy-page'>

            <div className='nav-wrapper'>
                <div className='nav-2'>

                    <div className='nav-logo-container'>
                        <img src='images/flashroom-logo-light.png' height="44px" />
                        <h1>Flash<span>Room</span></h1>
                    </div>

                    <div className='hamburger-menu-2' onClick={() => openNav(true)}>
                        <div />
                        <div />
                        <div />
                    </div>

                </div>
            </div>


            <div className={`nav-cont ${nav ? 'nav-open' : 'nav-closed'}`}>

                <div className='standard-xi-cont'

                    onClick={() => openNav(false)}
                >

                    <svg className="x-icon-sbn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 111.01 111.01">
                        <g id="Layer_3" data-name="Layer 3">
                            <path
                                className="cls-1"
                                d="M232.21,289.66a10.1,10.1,0,0,1-14.31,0l-38.22-38.22-38.23,38.23a10.13,10.13,0,0,1-14.32-14.32l38.23-38.23L127.14,198.9a10.12,10.12,0,1,1,14.31-14.31l38.22,38.22,38.23-38.23a10.13,10.13,0,0,1,14.32,14.32L194,237.13l38.22,38.22A10.12,10.12,0,0,1,232.21,289.66Z"
                                transform="translate(-124.17 -181.62)"
                            />
                        </g>
                    </svg>

                </div>

                <SBNav />

            </div>

            <div className="privacy-content">
                <div className="privacy-card">
                    <h1>Privacy Policy</h1>

                    <p className="effective-date">
                        <strong>Effective Date:</strong> February 3, 2026
                    </p>

                    <p>
                        FlashRoom respects your privacy. This Privacy Policy explains
                        what information we collect, how we use it, and the choices you have when you use FlashRoom
                    </p>

                    <div className="callout">
                        <h3>Beta Notice</h3>
                        <p>
                            FlashRoom is currently in beta. We’re actively improving the product, which means data handling,
                            features, and infrastructure may evolve over time. If we make meaningful changes to this policy,
                            we’ll update the effective date and publish the revised version here.
                        </p>
                    </div>

                    <h2>1. Information We Collect</h2>

                    <h3>A: Information you provide</h3>
                    <ul>
                        <li><strong>Room content:</strong> snippet names, text/code, folder names, and other content you create in rooms.</li>
                        <li><strong>Files you upload:</strong> documents, images, videos, archives, and other file types you choose to store in a room.</li>
                        <li><strong>Support messages:</strong> if you contact us, we may collect what you send (like your email and message contents).</li>
                    </ul>

                    <h3>B: Information we collect automatically</h3>
                    <ul>
                        <li><strong>Usage data:</strong> actions taken in the app (e.g., creating rooms, uploading files), timestamps, and basic performance metrics.</li>
                        <li><strong>Device/network data:</strong> IP address, browser type, and similar technical data used for security and debugging.</li>
                        <li><strong>Logs:</strong> server logs and error reports used to keep the Service stable and secure.</li>
                    </ul>

                    <h3>C: Authentication and access data</h3>
                    <p>
                        The Service uses authentication and room access controls (such as tokens) to protect rooms.
                        We may process identifiers and session/token data necessary to verify access and operate the Service.
                    </p>

                    <h2>2. How We Use Information</h2>
                    <p>We use the information we collect to:</p>
                    <ul>
                        <li>Provide and operate the Service (rooms, collaboration, file storage, and downloads).</li>
                        <li>Authenticate users and enforce room permissions.</li>
                        <li>Maintain security, prevent abuse, and investigate suspicious activity.</li>
                        <li>Fix bugs, monitor performance, and improve features.</li>
                        <li>Respond to support requests and communicate about important service-related updates.</li>
                    </ul>

                    <h2>3. How We Share Information</h2>
                    <p>
                        We do <strong>not</strong> sell your personal information. We only share information in limited situations:
                    </p>
                    <ul>
                        <li>
                            <strong>Service providers:</strong> We use third-party infrastructure providers to host the Service and store files
                            (for example, cloud hosting and object storage). They process data on our behalf to provide the Service.
                        </li>
                        <li>
                            <strong>Legal/safety:</strong> If required to comply with the law, respond to lawful requests, or protect the rights,
                            safety, and security of users and the Service.
                        </li>
                        <li>
                            <strong>Business changes:</strong> If FlashRoom is involved in a merger, acquisition, or asset sale, information may
                            be transferred as part of that transaction (we’ll take reasonable steps to notify users when required).
                        </li>
                    </ul>

                    <h2>4. File Storage and Downloads</h2>
                    <p>
                        Files you upload are stored using cloud infrastructure (including object storage). Access to files is controlled
                        by application permissions and may use time-limited links to allow downloads.
                    </p>
                    <p>
                        Please avoid uploading sensitive personal information (like government IDs, medical records, or financial account details)
                        during the beta.
                    </p>

                    <h2>5. Data Retention</h2>
                    <p>
                        We keep data only as long as needed to operate the Service, comply with legal obligations, and maintain security.
                        Because FlashRoom is in beta, we may remove inactive rooms or content as part of maintenance, storage limits,
                        or product changes.
                    </p>

                    <h2>6. Security</h2>
                    <p>
                        We use reasonable administrative, technical, and physical safeguards designed to protect your information.
                        However, no system is 100% secure. You are responsible for keeping room invite links/codes private and using
                        the Service responsibly.
                    </p>



                    <h2>7. Your Choices</h2>
                    <ul>
                        <li><strong>Delete content:</strong> If the Service provides deletion controls, you can delete certain room content and files.</li>
                        <li><strong>Request help:</strong> You can contact us to request deletion of certain data, subject to legal and operational requirements.</li>
                    </ul>

                    <h2>8. Changes to This Policy</h2>
                    <p>
                        We may update this Privacy Policy from time to time. If we make material changes, we will update the effective date
                        and post the updated policy on this page.
                    </p>

                    <h2>9. Contact</h2>
                    <p>
                        Questions about privacy? Email us at <a href="mailto:flashroomshare@gmail.com">flashroomshare@gmail.com</a>.
                    </p>

                    <div className="divider" />

                    <p className="fineprint">
                        This Privacy Policy is provided for informational purposes and does not constitute legal advice.
                    </p>
                </div>
            </div>


            <Footer />
        </div>
    )
}

export default Privacy
